if (!customElements.get('timeline-element')) {
  class Timeline extends HTMLElement {
    constructor() {
      super();
      this.container = this.querySelector('.timeline-content');
      this.items = this.container.querySelectorAll('.timeline-content__card');
      this.markers = this.querySelectorAll('.timeline-bar__marker');

      this.markers.forEach(marker => {
        marker.addEventListener('click', this.onMarkersClick.bind(this))
      })

      if (this.dataset.fullWidth == 'true') {
        this.style.setProperty('--section-offset', -this.container.offsetLeft + 'px');
        window.addEventListener('resize', () => {
          this.style.setProperty('--section-offset', -this.container.offsetLeft + 'px');
        });
      }

      if (this.container) {
        if (this.isMobile()) {
          this.container.style.overflow = 'hidden';
        }
        this.setUpDrag();
        this.onTouchMoveList()
      }

    }
    setUpDrag() {
      const container = this.container;
      const items = this.items;
      const _this = this;
      let isDragging = false;
      let startX;
      let startScrollLeft;

      container.addEventListener('mousedown', (e) => {
        e.preventDefault();
        container.style.cursor = 'grabbing';
        isDragging = true;
        startX = e.clientX;
        startScrollLeft = container.scrollLeft;

        document.addEventListener('mousemove', onMouseMove);
        window.addEventListener('mouseup', onMouseUp);
      });

      const onMouseMove = (e) => {
        e.preventDefault()
        if (!isDragging) return;

        const deltaX = e.clientX - startX;

        container.scrollLeft = startScrollLeft - deltaX;
      };

      const onMouseUp = () => {
        isDragging = false;
        document.removeEventListener('mousemove', onMouseMove);
        window.removeEventListener('mouseup', onMouseUp);
        container.style.cursor = 'grab';
        items.forEach((item, index) => {
          _this.snapToItem(item, index, items, container);
        })

      };

      container.addEventListener('mouseleave', () => {
        if (isDragging) {
          onMouseUp();
        }
      });

    }
    onTouchMoveList() {
      const container = this.container;
      const items = this.items;
      const _this = this;
      let isDragging = false;
      let startTouchX;
      let startScrollLeft;

      container.addEventListener('touchstart', (e) => {
        // e.preventDefault();
        container.style.cursor = 'grabbing';
        const touch = e.touches[0];
        isDragging = true;
        startTouchX = touch.clientX;
        startScrollLeft = container.scrollLeft;

        container.addEventListener('touchmove', onTouchMove);
        window.addEventListener('touchend', onTouchEnd);
      }, { passive: false });

      const onTouchMove = (e) => {
        if (!isDragging) return;

        const touch = e.touches[0];
        const deltaX = touch.clientX - startTouchX;

        container.scrollLeft = startScrollLeft - deltaX;
      };

      const onTouchEnd = () => {
        isDragging = false;
        container.removeEventListener('touchmove', onTouchMove);
        items.forEach((item, index) => {
          _this.snapToItem(item, index, items, container);
        });
        window.removeEventListener('touchend', onTouchEnd);
        container.style.cursor = 'grab';

      };

      container.addEventListener('touchcancel', () => {
        if (isDragging) {
          onTouchEnd();
        }
      });
    }
    snapToItem(item, index, items, container) {
      const maxScrollLeft = container.scrollWidth - container.clientWidth
      let conditional = item.offsetLeft - container.offsetLeft <= container.scrollLeft && (item.offsetLeft + item.clientWidth) - container.offsetLeft > container.scrollLeft;
      if (index == 0) {
        conditional = item.offsetLeft - container.offsetLeft <= container.scrollLeft && (item.offsetLeft + (item.clientWidth * 0.5)) - container.offsetLeft > container.scrollLeft;
      } else if (index > 0) {
        conditional = (item.offsetLeft - (items[index - 1].clientWidth * 0.5)) - container.offsetLeft <= container.scrollLeft && (item.offsetLeft + (item.clientWidth * 0.5)) - container.offsetLeft > container.scrollLeft;
      }

      if (index == items.length - 1) {
        if (container.scrollLeft >= (maxScrollLeft - (item.clientWidth * 0.4))) {
          conditional = true;
        }
      }

      if (container.scrollLeft <= 40) {
        if (index == 0) {
          conditional = true;
        }
        else {
          conditional = false;
        }
      }

      if (conditional) {
        container.scroll({
          left: item.offsetLeft - container.offsetLeft,
          behavior: "smooth"
        })
      }
    }
    isMobile() {
      let userAgent = navigator.userAgent || navigator.vendor || window.opera
      if (/android/i.test(userAgent)) {
        return true
      }
      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return true
      }

      return false
    }
    onMarkersClick(e) {
      this.items.forEach(item => {
        if (item.dataset.id === e.target.dataset.id) {
          this.container.scroll({
            left: item.offsetLeft - this.container.offsetLeft,
            behavior: "smooth"
          })
          item.classList.add('active');
          setTimeout(() => {
            if (item.dataset.keepActive == 'false') {
              item.classList.remove('active')
            }
          }, 750)
        } else {
          item.classList.remove('active')
        }
      })
    }
  }

  customElements.define('timeline-element', Timeline)
}